import styles from "../styles/profile.module.scss";
import { useEffect, useState } from "react";
import Subscriptions from "./Subscriptions";
import { useTranslation } from "react-i18next";
import MySubscriptions from "./MySubscriptions";
import { useAppSelector } from "../../../store/store";

const PrepaymentPage = () => {
  const { paymentTab } = useAppSelector((state: any) => state.navigation);

  const [currentTab, setCurrentTab] = useState(paymentTab || 0);
  const { t, i18n } = useTranslation();

  const userData = useAppSelector((state: any) => state.auth.userData);

  const currentTabHandler = (index: number) => {
    setCurrentTab(index);
  };

  useEffect(() => {
    setCurrentTab(paymentTab);
  }, [paymentTab]);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div>
      <div className={styles.accountTitle}>{t("subAndPay")}</div>
      <div className={styles.tabsBlock}>
        <div
          dir={dirData}
          onClick={() => currentTabHandler(0)}
          className={`
            ${styles.tab}
            ${currentTab === 0 && styles.active}
            ${currentTab === 2 && styles.additionalClass}
          `}
        >
          {t("subscriptions")}
        </div>
        <div onClick={() => currentTabHandler(2)} className={`${styles.tab} ${currentTab === 2 && styles.active}`}>
          {t("mySubs")}
        </div>
      </div>
      {currentTab === 0 && <Subscriptions />}
      {/*{currentTab === 1 && (<MyCards />)}*/}
      {currentTab === 2 && (
        <MySubscriptions
          currentOrder={userData?.order}
          planId={userData?.product_id}
          isSubscribed={userData?.is_subscribed}
          nextPay={userData?.next_pay_at}
          chooseSubscription={currentTabHandler}
        />
      )}
    </div>
  );
};

export default PrepaymentPage;
